import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";

/**
 * Architecture — Service 2 of 3: The Engine (Where Botany Meets Brutalism).
 * Formerly "Intelligent Workflow Design".
 */
const ArchitectureWorkflow = () => {
  return (
    <SectionLayout>
      <h2 className="glass-panel__title" data-testid="section-title">
        THE ENGINE: WHERE BOTANY MEETS BRUTALISM
      </h2>
      <p className="glass-panel__body" data-testid="section-body">
        This is the phase of active construction, where the heavy leverage
        of deep computation intersects with an organic, profoundly
        human-centric design. Whether we are deploying an intelligent
        front-line concierge, constructing an automated marketing pipeline,
        or forging a dynamic data vault, we engineer systems that execute
        with absolute machine precision while speaking exclusively in the
        nuanced voice of your brand.
      </p>
      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
        <Link
          to="/architecture/blueprint"
          className="glass-panel__btn glass-panel__btn--back"
          data-testid="btn-back"
        >
          The Blueprint
        </Link>
        <Link
          to="/architecture/world"
          className="glass-panel__btn glass-panel__btn--right"
          data-testid="btn-next"
        >
          The World
        </Link>
      </div>
    </SectionLayout>
  );
};

export default ArchitectureWorkflow;
